import React, {useEffect} from 'react';
import cn from 'classnames';

import {useLocation, useSetUI, useUI} from 'coreHooks';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';
import {useHeaderCtx} from 'brandComponents/Header/HeaderCtx';
import Icon from 'brandComponents/Icon';
import {useOpenedFlyouts} from 'brandHooks';

import MobileNavigationTriggersEffect from './MobileNavigationTriggersEffect';

import styles from './MobileNavigationTriggers.module.scss';

const MobileNavigationTriggers = () => {
	const {managerRepository} = useGeneralProvider();
	const setUI = useSetUI();
	const location = useLocation();
	const {isNavigationOpened} = useUI('header');
	const navigationStack = useUI('navigationStack');
	const headerCtx = useHeaderCtx(true);
	const navigationsStackSize = Object.keys(navigationStack || {}).length;
	const isQuickSearchOpen = useOpenedFlyouts('quickSearch').isOpen;

	//Close main-nav on mobile
	useEffect(() => {
		if (isNavigationOpened) {
			setUI.setHeader({isNavigationOpened: false});
			setUI.setNavigationStack({});
		}
	}, [location.pathname]);

	return (
		<div className={styles['header__navigation-actions']}>
			<MobileNavigationTriggersEffect />
			{isQuickSearchOpen
				? <Button
					variant="anything"
					onClick={() => managerRepository.getFlyoutsMgr().closeFlyout('quickSearch')}
				>
					<Icon name="close" height={20} width={20} />
				</Button>
				: <Button
					variant="anything"
					classNames={cn({[styles['active']]: !isNavigationOpened && !navigationsStackSize})}
					onClick={headerCtx?.handleNavigationVisibility}
				>
					<Icon name={isNavigationOpened ? 'close' : 'menu'} height={20} width={20} />
				</Button>
			}
		</div>
	);
};

export default MobileNavigationTriggers;
